import React, { PropTypes, PureComponent } from 'react';

import Tooltip from '../../../Tooltip';

import { benefits, info, tick, tooltip } from './styles.module.css';

/**
 * Presentational component for booking partner benefits.
 */
class Benefits extends PureComponent {
  state = {
    priceTooltipVisible: false,
    cancellationTooltipVisible: false,
  };

  toggleTooptip = (name) => {
    this.setState({
      priceTooltipVisible: false,
      cancellationTooltipVisible: false,
      [name]: true,
    });
  };

  render() {
    const { organiser } = this.props;
    const { priceTooltipVisible, cancellationTooltipVisible } = this.state;
    return (
      <ul className={benefits}>
        <li>
          <span className={tick} />
          <span>
            {'Official booking partner'}
            {organiser && ' of '}
            {organiser && <span>{organiser.title}</span>}
          </span>
        </li>
        <li
          onMouseEnter={() => this.toggleTooptip('priceTooltipVisible')}
          onMouseLeave={() => this.toggleTooptip()}
        >
          {priceTooltipVisible && (
            <Tooltip
              text="If you find this ticket cheaper anywhere else, we’ll refund the difference"
              className={tooltip}
            />
          )}
          <span className={info} />
          <span>{'Best price guarantee'}</span>
        </li>
        <li
          onMouseEnter={() => this.toggleTooptip('cancellationTooltipVisible')}
          onMouseLeave={() => this.toggleTooptip()}
        >
          {cancellationTooltipVisible && (
            <Tooltip
              text="If you need to withdraw due to injury or the race is cancelled we’ll refund your ticket"
              className={tooltip}
            />
          )}
          <span className={info} />
          <span>{'Free cancellation protection'}</span>
        </li>
      </ul>
    );
  }
}

Benefits.propTypes = {
  organiser: PropTypes.shape({
    permalink: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
};

Benefits.defaultProps = {
  organiser: undefined,
};

export default Benefits;



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/BookNow/Benefits/index.jsx